export function getFileName(file: any) {
  return file?.name || '';
}

export function getObsKey(file: any) {
  if (
    file?.transcoded_obskey &&
    file?.transcoded_obskey !== ''
  ) {
    return file?.transcoded_obskey;
  }
  return file?.obskey || file?.original_file_url;
}

export function getExtFromName(name: any) {
  return name?.split('.').pop()?.toLowerCase() || '';
}

export function getFileNameFromObsKey(obsKey?: string) {
  if (!obsKey) return '';

  const parts = obsKey.split('/');

  return parts[parts.length - 1] || '';
}

export function getExt(ext: any) {
  const finalExt = ext?.toLowerCase();
  return finalExt || '';
}

export function getPreviewType(extension: any) {
  const ext = getExt(extension);

  if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'].includes(ext)) {
    return 'image';
  }

  if (['mp4', 'webm', 'ogg', 'mov', 'avi', 'wmv', 'mkv', 'flv'].includes(ext)) {
    return 'video';
  }

  if (['pdf'].includes(ext)) {
    return 'pdf';
  }

  if (['mp3', 'wav', 'ogg', 'aac', 'm4a', 'wma', 'flac'].includes(ext)) {
    return 'audio';
  }

  if (['js', 'ts', 'tsx', 'jsx', 'css', 'scss', 'less', 'html', 'htm', 'vue', 'svelte',
    'py', 'java', 'cpp', 'c', 'h', 'hpp', 'go', 'rb', 'php', 'swift', 'kt', 'rs',
    'sh', 'bash', 'sql', 'yaml', 'yml', 'xml', 'toml', 'json', 'md', 'r', 'pl',
    'lua', 'dart', 'scala', 'groovy', 'perl', 'asm', 'vb', 'cs', 'fs', 'clj',
    'hs', 'erl', 'ex', 'elm'].includes(ext)) {
    return 'code';
  }

  if (['txt', 'log'].includes(ext)) {
    return 'text';
  }

  if (['doc', 'docx'].includes(ext)) {
    return 'word';
  }

  if (['xls', 'xlsx', 'csv'].includes(ext)) {
    return 'excel';
  }

  if (['ppt', 'pptx'].includes(ext)) {
    return 'ppt';
  }

  if (['zip', 'rar', '7z'].includes(ext)) {
    return 'zip';
  }

  if (['ai'].includes(ext)) {
    return 'ai';
  }

  return 'default';
}

export function getOfficePreviewUrl(url: string) {
  return `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(url)}`;
}

export function getFileViewPreviewUrl(url: string, fileName: string) {
  return `https://fileview.bestjl.com/preview/view?path=${encodeURIComponent(`/${url}`)}&fileName=${encodeURIComponent(fileName)}&mode=embed`;
}
